<app-modal-bg (modalClick)="onClose.emit()">
    <app-modal-card
        class="w-[446px]"
        imgPreHeader="{{ imgPreHeader }}"
        [hasCloseBtn]="false"
        [header]="header">
        <div class="main text-left text-zinc-500">
            <p class="mb-5">
                {{ TEXT.upgradedGrowthPlan.message.first }}
            </p>
            <p>
                {{ TEXT.upgradedGrowthPlan.message.second }}
            </p>
        </div>
        <footer class="mt-[38px] flex gap-4">
            <app-button (btnClick)="onClose.emit()">
                {{ TEXT.goIt }}
            </app-button>
        </footer>
    </app-modal-card>
</app-modal-bg>
